import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		tableHeader_header: {
			'& > tr > th:first-child': {
				borderRadius: '10px 0px 0px 0px',
			},
			'& > tr > th:last-child': {
				borderRadius: '0px 10px 0px 0px',
			}
		},
    });
});

export default useStyles;
